export default function WalletProvider({ children }) {
  return children;
}
